import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const AutomationFeatures = () => {
  const features = [
    {
      icon: 'bi-chat-dots',
      title: 'Dual Communication Types',
      description: 'Email and WhatsApp integration for comprehensive outreach',
      color: 'text-primary'
    },
    {
      icon: 'bi-clock',
      title: 'Smart Timing',
      description: 'Customizable scheduling for optimal engagement timing',
      color: 'text-success'
    },
    {
      icon: 'bi-lightning-charge',
      title: 'Instant Automation',
      description: 'Immediate response triggers for real-time lead engagement',
      color: 'text-warning'
    },
    {
      icon: 'bi-broadcast',
      title: 'Multi-Channel Reach',
      description: 'Simultaneous communication across multiple platforms',
      color: 'text-info'
    }
  ];

  return (
    <div className="mb-4">
      <h5 className="fw-bold mb-3">Automation Features</h5>
      <Row>
        {features.map((feature, index) => (
          <Col md={6} lg={3} key={index} className="mb-3">
            <Card className="border-0 shadow-sm h-100 text-center">
              <Card.Body className="p-4">
                <div className="mb-3">
                  <i className={`bi ${feature.icon} fs-1 ${feature.color}`}></i>
                </div>
                <h6 className="fw-bold mb-2">{feature.title}</h6>
                <p className="text-muted small mb-0">{feature.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AutomationFeatures; 